import { render, staticRenderFns } from "./AdminManageLawsCollections.vue?vue&type=template&id=1519834a"
import script from "./AdminManageLawsCollections.vue?vue&type=script&lang=js"
export * from "./AdminManageLawsCollections.vue?vue&type=script&lang=js"
import style0 from "./AdminManageLawsCollections.vue?vue&type=style&index=0&id=1519834a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1519834a')) {
      api.createRecord('1519834a', component.options)
    } else {
      api.reload('1519834a', component.options)
    }
    module.hot.accept("./AdminManageLawsCollections.vue?vue&type=template&id=1519834a", function () {
      api.rerender('1519834a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminManageLawsCollections.vue"
export default component.exports